module.exports = __webpack_public_path__ + "static/media/day05_safari.75a3d8bb.gif";